import React from 'react';
import PropTypes from 'prop-types';
import Grid from '../components/Grid.jsx';
import FormikDateTimePicker from '../formik-fields/FormikDateTimePicker.jsx';

const GridFormikDatePicker = ({ gridProps, ...props }) => {
  return (
    <Grid item {...gridProps}>
      <FormikDateTimePicker {...props} />
    </Grid>
  );
};

GridFormikDatePicker.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  format: PropTypes.string,
  valueFormat: PropTypes.string,
  gridProps: PropTypes.object.isRequired,
};

export default GridFormikDatePicker;
